export default {
    HEADER_TITLE: "ПАРАМЕТРЫ МЕТОДОВ",
    DELETE: "Удалить из очереди",
    CLEAR: "Сбросить все",
    CREATE_SCRIPT: "Создать скрипт"
};
